import { render, staticRenderFns } from "./Electronpop2.vue?vue&type=template&id=2be34842&scoped=true"
import script from "./Electronpop2.vue?vue&type=script&lang=js"
export * from "./Electronpop2.vue?vue&type=script&lang=js"
import style0 from "./Electronpop2.vue?vue&type=style&index=0&id=2be34842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be34842",
  null
  
)

export default component.exports